// extracted by mini-css-extract-plugin
module.exports = {"muteButton":"MuteButton_muteButton__XJAoP"};